import Svg from "@/components/base/Svg"
import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { ChangeEvent, CSSProperties, InputHTMLAttributes } from "react"

const Container = styled.div``

const InputWrap = styled.div`
    display: flex;
    align-items: center;
    border-radius: 8rem;
    border-style: solid;
    border-width: 1rem;
    height: 48rem;
    line-height: 48rem;
    overflow: hidden;
    padding: 12rem 16rem;
`

const Input = styled.input`
    height: 25rem;
    line-height: 25rem;
    vertical-align: middle;
    font-size: 20rem;
    font-family: Gilroy;
    font-weight: 500;
    color: #131416;
    flex: 1;
    outline: none;
    border: none;
    background-color: transparent;
    margin: 0;
    padding: 0;
    &::placeholder {
        color: #9fa7bc;
        font-family: Gilroy;
        font-weight: 400;
        font-size: 16rem;
    }
`

const ErrorMessage = styled.div`
    display: flex;
    align-items: center;
    margin-top: 8rem;
`

const ErrorText = styled.span`
    color: #f51450;
    font-family: Gilroy;
    font-size: 12rem;
    font-weight: 400;
    line-height: 16rem;
    padding-left: 4rem;
    vertical-align: middle;
`

export interface Props
    extends Omit<InputHTMLAttributes<HTMLInputElement>, "onChange" | "onInput" | "prefix"> {
    errorMsg: string
    value: string
    className?: string
    containerStyle?: CSSProperties
    inputStyle?: CSSProperties
    prefix?: React.ReactNode
    onChange: (v: string) => void
}

export default function ValueInput(props: Props) {
    const {
        onChange,
        containerStyle = {},
        inputStyle = {},
        errorMsg = "",
        value = "",
        className,
        maxLength = 50,
        prefix,
        ...rest
    } = props
    const showError = errorMsg.length > 0
    return (
        <Container
            className={className}
            style={containerStyle}
        >
            <InputWrap
                css={css`
                    ${showError
                        ? `
                            border-color: #f51450;
                            background-color: #fee2e9;
                        `
                        : `
                            border-color: #c5cad8;
                            background-color: #fcfcfd;
                        `}
                `}
            >
                {prefix}
                <Input
                    type="text"
                    value={value}
                    maxLength={maxLength}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
                    style={inputStyle}
                    {...rest}
                    css={css`
                        ${showError ? `&::placeholder { color: #f51450; }` : ``}
                    `}
                />
                {value ? (
                    <Svg
                        src={
                            showError
                                ? "components/form_item/clear_text_red_icon.svg"
                                : "components/form_item/clear_text_icon.svg"
                        }
                        onClick={() => onChange("")}
                        style={{ cursor: "pointer" }}
                    />
                ) : null}
            </InputWrap>

            {showError ? (
                <ErrorMessage>
                    <Svg src="components/form_item/public_fail_icon.svg" />
                    <ErrorText>{errorMsg}</ErrorText>
                </ErrorMessage>
            ) : null}
        </Container>
    )
}
